import { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext(null);

export function ModalProvider({ children, dark }) {
  const [modal, setModal] = useState(null);

  const showModal = useCallback(({ type = 'error', title, message }) => {
    setModal({ type, title, message });
  }, []);

  const closeModal = () => setModal(null);

  const icons = {
    error: 'ti-alert-circle',
    success: 'ti-check',
    warning: 'ti-alert-triangle',
  };
  const colors = {
    error: '#FF4500',
    success: '#22c55e',
    warning: '#f59e0b',
  };

  const c = {
    overlay: 'rgba(0,0,0,0.6)',
    card: dark ? '#1c1c1c' : '#ffffff',
    text: dark ? '#eeeeee' : '#111111',
    sub: dark ? '#999999' : '#666666',
  };

  return (
    <ModalContext.Provider value={{ showModal, closeModal }}>
      {children}
      {modal && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed', inset: 0, background: c.overlay,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000, padding: '20px', fontFamily: 'Prompt,sans-serif'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: c.card, borderRadius: '16px', padding: '24px 20px',
              width: '100%', maxWidth: '320px', textAlign: 'center'
            }}
          >
            <div style={{
              width: '52px', height: '52px', borderRadius: '50%',
              background: `${colors[modal.type]}1a`, border: `2px solid ${colors[modal.type]}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 14px'
            }}>
              <i className={`ti ${icons[modal.type]}`} style={{ fontSize: '24px', color: colors[modal.type] }} aria-hidden="true" />
            </div>
            {modal.title && (
              <p style={{ fontSize: '15px', fontWeight: '700', color: c.text, margin: '0 0 6px' }}>{modal.title}</p>
            )}
            <p style={{ fontSize: '12px', color: c.sub, margin: 0, lineHeight: 1.6 }}>{modal.message}</p>
            <button
              onClick={closeModal}
              style={{
                width: '100%', marginTop: '18px', padding: '11px', border: 'none',
                borderRadius: '10px', background: colors[modal.type], color: '#fff',
                fontSize: '13px', fontWeight: '700', cursor: 'pointer', fontFamily: 'Prompt,sans-serif'
              }}
            >
              ตกลง
            </button>
          </div>
        </div>
      )}
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}